import styled from 'styled-components'

export const SalonImage = styled.img`
	display: block;
`
